// English locale. Keys mirror ru.js — add every new key to both files.
export default {
  common: {
    ok: 'OK',
    back: 'Back',
    close: 'Close',
    cancel: 'Cancel',
    later: 'Later',
    save: 'Save',
    loading: 'Loading…',
    energy: 'Energy',
    rating: 'Rating',
    tickets: 'Tickets',
    materials: 'Materials',
    gems: 'Gems',
    player: 'Player',
    place: 'Place',
    you: 'you',
    skip: 'Skip',
    on: 'on',
    off: 'off',
    networkError: 'Network unavailable. Check your connection.',
  },
  menu: {
    campaign: 'New Campaign',
    campaignSoon: 'in development',
    pvp: 'PVP',
    daily: 'Daily quests',
    tournaments: 'Tournaments',
    options: 'Options',
    profile: 'Profile',
    wiki: 'Help',
  },
  options: {
    title: 'Options',
    subtitle: 'Interface language and game settings',
    languageTitle: 'Language',
    languageHint: 'The interface, hints and game messages switch instantly — your choice is saved on this device.',
    languageAuto: 'Detected from your device language',
    languageSaved: 'Language saved',
    soon: 'Soon',
    soundTitle: 'Sound',
    soundHint: 'Sound settings will arrive in a future update.',
  },
  app: {
    build: 'build',
    rotatePhone: 'Rotate your phone to landscape',
    updateAvailable: 'A game update is available — it will apply once you return to the lobby.',
    preloading: 'Loading game content…',
    maintenance: 'Maintenance in progress,',
    maintenanceSorry: 'sorry for the inconvenience.',
    maintenanceIn: 'In',
    maintenanceBanner: '{when} the servers go down for maintenance — please finish your matches before that.',
    seasonBanner: '🏆 Tournament: {title}',
    seasonExit: 'Back to main account',
    tourStartIn: 'Starts in',
    tourEndsIn: 'Tournament ends in',
    tourClaimUntil: 'Claim rewards before',
    greyList: 'Your account is greylisted.\nWe are monitoring your activity.',
    blackList: 'Your account is blacklisted. Rewards are not granted.\nContact support to resolve this.',
  },
  time: {
    d: 'd',
    h: 'h',
    m: 'm',
    s: 's',
    min: 'min',
  },
  profile: {
    connectWallet: 'connect wallet',
    settingsFigures: 'Piece Settings',
    wheel: 'Wheel of Fortune',
    market: 'Market',
    starsShop: 'Shop ⭐',
    tournaments: 'Tournaments',
    logout: 'Log out',
    changePassword: 'Change password',
    pwdOld: 'Current password',
    pwdNew: 'New password',
    pwdChanged: 'Password changed',
    pwdHint: 'All your other sessions (tournament ones included) will be signed out.',
    tgLink: 'Link Telegram',
    tgLinked: 'Telegram linked — the mini app will sign you in instantly from now on.',
    tgLinkFailed: 'Could not link Telegram. Try reopening the game from Telegram.',
    tgSwitch: 'I already have a game account',
    tgUnlink: 'Unlink Telegram',
    tgUnlinked: 'Telegram unlinked. You can now link it to another account of yours.',
    tgAppHint: 'Linking goes through our Telegram mini app: the link below opens it in your Telegram and links the account.',
    tgOpenApp: 'Open the mini app',
    tgCodeHint: 'The link works for 10 minutes. Open it on your phone or in the Telegram app — the account will be linked automatically.',
    tgCodeFailed: 'The link did not work: it has expired or was already used. Get a new one in your profile.',
    statistic: 'Player statistic',
    totalGames: 'Total games',
    wins: 'Wins',
    loses: 'Loses',
    energyTotal: 'Total energy received',
    nft: 'NFT warriors',
    nftConnect: 'Connect a TON wallet to see your NFT warriors.',
    nftAll: 'All',
    nftNoneInFilter: 'No pieces of this faction.',
    nftInArmy: 'in army',
    nftInArmyFull: 'This piece stands in your army',
    nftOnBench: 'The piece is in the game, waiting in reserve with its own gear',
    nftNoStats: 'Stats for this piece are not available yet.',
    nftStatsWithAmmo: 'In-game stats, equipment included ({n} items)',
    nftStatsNoAmmo: 'In-game stats: no equipment on',
    nftStatsPreview: 'Stats this piece will have in game (no equipment)',
    nftEmpty: 'No pieces from our collection on this wallet.',
    walletWait: 'confirm in your wallet…',
    walletBalance: '$ENRG balance: {n}',
    walletBalanceHint: '$ENRG tokens on the linked wallet',
    walletRefresh: 'Refresh data from the blockchain',
    dataAgeMin: 'data {n} min old',
    dataAgeHour: 'data {n} h old',
    walletRetry: 'Retry',
    walletUnlink: 'Unlink',
    unlinkTitle: 'Unlink the wallet?',
    unlinkWarn: 'NFT figures ({n}) will leave the game — your own figures return to their places in the squad.',
    unlinkGear: 'Their equipment and inventory go back to your chest. Baked equipment stays on the NFT and returns with it.',
    unlinkOk: 'Unlink',
    unlinkDone: 'Wallet unlinked. Figures removed: {u}, items returned to the chest: {n}.',
    walletNoProof: 'The wallet did not prove ownership. Try another wallet or update the app.',
    walletBusy: 'The wallet still holds the previous connection. Close the wallet app and tap again.',
    walletTimeout: 'No confirmation came from the wallet. Please try again.',
    walletCancelled: 'The connection was not completed — please try again.',
    bakeOk: 'Bake the kit',
    bakeTitle: 'Bake the kit?',
    bakeWarn: 'The kit gets locked to the NFT: you will not be able to take it off, move it to another figure, sell, dismantle or let auto-equip touch it. If you sell the figure, the items go to the buyer.',
    bakePrice: 'Price: {n} energy from your balance. Unlocking is free.',
    bakeNoGear: 'The figure has no equipment — nothing to bake',
    bakeStepPaid: 'Paid',
    bakeStepKit: 'Kit locked to the NFT',
    bakeStepFree: 'Seal removed, the items are yours again',
    bakeStepCard: 'NFT card updated',
    bakeCardWait: 'The card will be updated shortly — the in-game part is already done.',
    bakeGetgems: 'On Getgems the card is not updated instantly: it has its own cache, refresh it from the item page.',
    unbakeOk: 'Unlock',
    unbakeTitle: 'Unlock the kit?',
    unbakeWarn: 'The seal comes off and the items become ordinary equipment again — you can take them off, sell and dismantle them. Unlocking is free.',
    takeOk: 'Take into the game',
    takeTitle: 'Take the kit into the game?',
    nftBaked: 'Kit is baked',
    nftEnergyBonus: '+{pct}% energy per enemy piece it captures',
    exchangeOpen: 'Exchange',
    exchangeTitle: 'Exchange $ENRG for energy',
    exchangeRate: 'Rate 1:1, whole tokens only. Tokens are burned for good, energy goes to your balance.',
    exchangeAmount: 'How many tokens',
    exchangeGets: 'You get energy: {n}',
    exchangeGas: 'The network fee is paid by your wallet — keep a little GRAM on it.',
    exchangeToday: 'Exchanged today: {n}',
    exchangeOk: 'Exchange',
    exchangeBusy: 'Waiting for signature…',
    exchangeWaiting: 'Sent. Waiting for the blockchain to see it — usually 1-2 minutes. You can close this window: the energy will arrive on its own, and the profile keeps a pending note.',
    exchangeDone: 'Done: {n} energy credited.',
    exchangeDeferred: 'The burn is accepted, but today\u2019s exchange limit is used up: {n} energy will be credited once the limit resets. The tokens are safe, nothing to do.',
    // 🔴 Not an error but the normal course of events — the text must calm and say what to do (nothing).
    exchangeSlow: 'The blockchain is still confirming the transaction — that is normal. The energy will arrive on its own; you can close this window, we will tell you about it here in the profile.',
    exchangePending: '⏳ Exchange in progress: {n} energy will arrive once the blockchain confirms it (usually 1-2 minutes).',
    nftNoticeExchange: '✅ $ENRG exchange complete: {n} energy credited.',
    exchangeInApp: 'Exchanging $ENRG for energy is available on the game website, outside Telegram.',
    exchangeConnect: 'Connect wallet',
    exchangeWaitWallet: 'Waiting for the wallet…',
    exchangeBridgeOn: 'Wallet {addr} is connected in this browser.',
    exchangeBridgeOff: 'No wallet is connected in this browser — signing is not possible yet.',
    exchangeNeedConnect: 'To sign the operation, connect your wallet in this browser. Your account link stays as it is.',
    walletMismatch: 'A different wallet is connected in your browser. Disconnect it and connect the one linked to your account.',
    walletRaw: 'The wallet refused: {text}',
    nftNoticeGone: 'The NFT warrior ({who}) is no longer in your wallet — the piece left your squad and your own one took its place.',
    nftNoticeListed: 'The NFT warrior ({who}) is listed for sale: the energy bonus is off and its gear went back to the chest.',
    nftNoticeItems: 'Items returned to the chest: {n}.',
    nftNoticeRentBack: 'Your rented figure is back: {who}.',
    nftNoticeCount: 'messages: {n}',
    nftNoticeClose: 'Dismiss message',
    nftSomeFigure: 'a figure',
    referralTitle: 'Invite friends — earn tickets 🎟️',
    referralWhy: 'A friend who signs up via your link gets 5 wheel tickets; you get one ticket per match they play, up to 5 per friend',
    invited: 'Invited',
    copy: 'Copy',
    copied: 'Copied',
    gemHint: '{name} — hover/tap for a breakdown by size',
    gemBySize: '{name} by size',
  },
  login: {
    signUp: 'Sign up',
    login: 'Login',
    username: 'Username',
    password: 'Password',
    email: 'E-mail',
    submit: 'OK',
    failed: 'Sign-in failed. Check your name and password',
  },
  pvp: {
    start: 'Start',
    yourPower: 'Your power',
    oppPower: 'Opponent power',
    deviation: 'Opponent power deviation',
    gameMode: 'Game mode',
    modeKillKingTimer: 'Kill the king in 20 minutes',
    allowBot: 'Allow bot opponents',
    allowBotHint: 'Bot matches give no energy, rating or loot',
    botSurrender: 'Let the bot surrender when hopelessly losing',
    botSurrenderHint: 'Uncheck to finish the bot off completely',
    botDifficulty: 'Bot difficulty',
    botEasy: 'Easy',
    botMedium: 'Medium',
    botHard: 'Hard',
    // Names below are left over from the previous eight-step scale (levels 3-7): the slider no
    // longer shows them, but the message catalogue and older builds still reference the keys.
    botSkilled: 'Skilled',
    botExpert: 'Expert',
    botMaster: 'Master',
    botGrand: 'Grandmaster',
    botLegend: 'Legend',
    botEasyHint: 'Plays without the tactical force map and makes mistakes. The match gives nothing',
    botMediumHint: 'Sees the force map but does not calculate ahead. Drops gear and resources; rating and wins are not counted',
    botHardHint: 'Calculates the game ahead and thinks up to 30 seconds per move, smart combat and king. Drops gear, resources and energy to your balance for captured figures; rating and wins are not counted',
    botBrainHint: 'Calculates the game {n} moves ahead, thinking up to 5 seconds per move. Rewards are the same as Hard; rating and wins are not counted',
    vs: 'vs',
    activeMatches: 'Live matches',
    watchActive: 'Watch live matches',
    noActive: 'No live matches right now',
    returnToMatch: 'Return to match',
    surrender: 'Surrender',
    surrenderConfirm: 'Surrender the current match? It will count as a loss.',
    figures: 'Piece Settings',
    tourNotStarted: 'The tournament has not started yet',
    fightInProgress: 'Battle in progress',
    viewers: 'Viewers',
    likes: 'Likes',
  },
  leaderboard: {
    name: 'Name',
    power: 'T. Power',
    win: 'Win',
    lose: 'Lose',
    energy: 'T. Energy',
    rating: 'Rating',
    viewFigures: "View this player's piece settings",
  },
  wheel: {
    ammoWon: '{rarity} item (lvl {level}) — to chest',
    boxWon: 'A {rarity} chest — opens in {time}',
    boxesWon: 'chests: {n} — waiting in your storage',
    sector_energy: 'Energy',
    sector_material: 'Materials',
    sector_gem: 'Gems',
    sector_ammo_common: 'Common',
    sector_ammo_rare: 'Rare',
    sector_ammo_super_rare: 'Super rare',
    sector_ammo_unique: 'Unique',
    sector_ammo_epic: 'Epic',
    title: 'Wheel of Fortune',
    tickets: 'Tickets: {n}',
    spin1: 'Spin ×1',
    spinN: 'Spin ×{n}',
    spinning: 'Spinning…',
    noTickets: 'No tickets',
    fewTickets: 'Not enough tickets',
    boost: 'The wheel has boosted rare drops: unique gear drops 3× more often, and epic gear 10× more often, than in a match.',
    buyTickets: 'Buy tickets',
    buy: 'Buy',
    ticketPrice: '1 ticket = {energy} ⚡ + {gems} gem(s) + {materials} material(s) (random)',
    total: 'Total: {energy} ⚡ + {gems} gem(s) + {materials} material(s)',
    dailyLimit: 'Up to {n} tickets per day',
    canBuyNow: 'Available to buy: {n}',
    cannotBuy: 'Nothing to buy right now: not enough resources or the daily limit is reached',
    dailyDone: 'Daily purchase limit reached — you can buy more tomorrow',
    resultOne: 'Spin result',
    resultMany: 'Result of {n} spins',
    nothing: 'Nothing this time.',
    rewardTaken: 'Reward received.',
    rewardBlocked: 'Reward unavailable (account is restricted).',
    itemLost: 'An item dropped, but your storage is full — it was lost.',
    lost: 'Lost (storage full): {n}',
    toChest: 'To chest',
    take: 'Claim',
    noAmmo: 'No gear dropped',
    noRes: 'No resources dropped',
    energyLine: '⚡ Energy:',
    gemsLine: '💎 Small gems:',
    matsLine: '🪵 Materials:',
    energyToBalance: 'Energy (to balance)',
    notEnoughEnergy: 'Not enough energy',
    notEnoughGems: 'Not enough gems',
    notEnoughMats: 'Not enough materials',
    buyFailed: 'Could not buy tickets',
  },
  kind: {
    helmet: 'Helmet', pauldrons: 'Pauldrons', bracers: 'Bracers', cuirass: 'Cuirass', pants: 'Pants',
    belt: 'Belt', boots: 'Boots', gloves: 'Gloves', shield: 'Shield', quiver: 'Quiver',
    amulet: 'Amulet', ring: 'Ring', sword: 'Sword', bow: 'Bow', staff: 'Staff', axe: 'Axe',
    knife: 'Knife', flask: 'Flask', bridle: 'Bridle', spellbook: 'Spellbook',
    wall_talisman: 'Wall talisman', cloak: 'Cloak', mind_cast: 'Mind cast',
    ammo: 'gear', level: 'lvl',
  },
  tour: {
    errLoad: 'Failed to load tournaments',
    flowReg: 'Sign-up',
    flowActive: 'Live',
    flowResults: 'Results',
    flowTransfer: 'Reward transfer',
    title: 'Tournaments',
    subtitle: 'Separate profile · equal start · valuable rewards',
    footer: 'One tournament at a time · the tournament profile is separate: your main pieces and gear stay put',
    ticketsPill: '🎟 Tickets: {n}',
    tabActive: 'Current',
    tabMine: 'Mine',
    tabHall: 'Hall of fame',
    stateRegistration: 'Sign-up',
    stateActive: 'Live',
    stateFinished: 'Finished',
    stateArchived: 'Archived',
    btnJoin: 'Join',
    btnEnter: 'Continue tournament',
    btnBoard: 'Standings',
    btnDetails: 'Details',
    btnClaim: 'Claim reward',
    btnFull: 'Full',
    youParticipate: "you're in",
    nearest: 'next tournament',
    placeOf: 'place of {n}',
    rating: 'rating',
    wins: 'W–L',
    toPrizes: 'places to prizes',
    inPrizes: "you're in the prizes",
    start: 'start',
    finish: 'finish',
    participants: 'participants',
    participantsN: '{n} participants',
    seatsOf: '{n} of {max}',
    prize: 'prize',
    entry: 'entry',
    entryFree: 'free',
    claimUntil: 'claim before',
    claimIn: 'claim within',
    untilStart: 'starts in',
    untilEnd: 'ends in',
    untilRegEnd: 'sign-up ends in',
    youTook: 'you finished {n}th',
    allTournaments: '← All tournaments',
    backToCard: 'Back to tournament',
    myFigures: 'My pieces',
    boardTitle: 'Standings',
    boardOf: 'Standings · {title}',
    boardSub: '{n} participants · updated after every match',
    boardNote: 'Place is based on tournament rating: energy earned, weighted by win rate',
    boardEmpty: 'No participants yet.',
    boardLoading: 'Loading standings…',
    boardAll: 'full standings',
    boardGap: '{gap} rating short of place {n}',
    rewardsTitle: 'Prizes',
    rewardsEmpty: 'Prizes will be announced later.',
    rewardsNote: 'Prizes land in your tournament profile. You can move them to the main account until {date}.',
    myInterval: 'your bracket',
    rulesOwn: '📜 Tournament rules',
    rulesCommon: '📖 General tournament rules',
    rulesJoin: '🧭 How participation works',
    joinTitle: 'Join the “{title}” tournament?',
    joinFree: 'Free entry',
    joinPrice: 'Entry: {n} 🎟',
    joinOnce: 'One tournament at a time',
    joinConfirm: 'Join tournament',
    joinFull: 'All seats are taken',
    joinBusy: "You're already in a tournament",
    claimTitle: 'Tournament reward',
    claimInterval: 'reward bracket {label}',
    claimWhere: 'Everything moves to your main account: gear to the chest, resources and energy to the balance.',
    claimDeadline: 'You can claim until {date}. After that the tournament profile and its contents are deleted.',
    claimBtn: 'Claim to main account',
    claimDone: 'Reward credited to your main account',
    claimNothing: 'Nothing to transfer.',
    claimNoPrize: 'No prize for your place, but everything you earned in the tournament can still be moved.',
    itemsCount: 'items',
    energyCount: 'energy',
    hallTitle: 'Your trophies',
    hallSubtitle: 'all time',
    hallPlayed: 'tournaments played',
    hallWins: 'wins',
    hallPrizes: 'times in prizes',
    hallNotPlayed: "You didn't take part",
    hallPlayed1: 'You took part',
    hallEmpty: 'No finished tournaments yet.',
    hallNote: 'Tap a tournament to see its full standings and prize list',
    emptyTitle: 'No tournaments right now',
    emptyText: 'The next tournament will be announced here — sign-up usually opens a few days before the start.',
    backToProfile: 'Back to profile',
    inSeason: "You're in a tournament",
    inSeasonHint: 'you are playing in the tournament profile',
    menuBtn: 'Tournament menu',
    exit: 'Back to main profile',
    errJoin: 'Could not sign up',
    errEnter: 'Could not enter',
    errTransfer: 'Could not transfer',
    deskTitle: 'Tournament profile',
    deskSubtitle: 'everything inside the tournament is separate from your main account',
    deskProgress: 'Your tournament progress',
    deskNote: 'Your main account is paused while you are in the tournament: rating, pieces and gear stay unchanged',
    deskWaiting: 'waiting for the tournament to start',
    deskNotStarted: 'The tournament has not started yet',
    deskOpensOnStart: 'opens when the tournament starts',
    tilePlay: 'Battle|opponents are tournament players only',
    tilePack: 'My pieces|gear and settings of your tournament army',
    tileBoard: 'Standings|your place and the leaders',
    tileMarket: 'Tournament market|trading inside the tournament only',
    tileWheel: 'Wheel of Fortune|tickets and random prizes',
    tileRewards: 'Prizes|what your place pays',
    tileRules: 'Rules|dates, prizes, transfer terms',
    collapse: 'Collapse',
    rulesOwnPlain: 'Rules of this tournament',
    rulesCommonPlain: 'General tournament rules',
    rulesJoinPlain: 'How participation works',
    played: '{n} matches played',
    inPrizeZone: "you're in the prize zone",
    toPrizesN: '{n} places to prizes',
    placeShort: 'place',
  },
  // TELEGRAM STARS SHOP. Product titles/descriptions come FROM THE SERVER (edited in admin) and are
  // not translated — what is translated is the CONTENTS of a bundle and the whole surrounding text.
  stars: {
    title: 'Shop',
    subtitle: 'Bundles for Telegram Stars',
    buy: 'Buy',
    buying: 'Opening invoice…',
    guaranteed: 'Guaranteed: {rarity} item, level {level}',
    guaranteedKind: 'Guaranteed: {kind} ({rarity}), level {level}',
    oddsTitle: 'Odds by item type',
    kitsTitle: 'Bundles',
    kitsNote: 'fixed contents — what you see is what you get',
    boxesTitle: 'Chests',
    boxesNote: 'rarity and level are guaranteed, the item type is random',
    badge: {
      starter: 'Starter',
      hit: 'Popular',
      value: 'Best value',
      best: 'Top tier',
    },
    oddsHint: 'Rarity and level are guaranteed, only the type is random. The percentages come from the very tables the game rolls the item with.',
    limit: 'bought today: {n} of {of}',
    limitWeek: 'bought this week: {n} of {of}',
    limitMonth: 'bought in 30 days: {n} of {of}',
    refresh: 'Refresh',
    closed: 'The shop is closed for now.',
    empty: 'No bundles right now.',
    noLink: 'Could not open the invoice — please try again.',
    payFailed: 'Payment did not go through. No stars were charged.',
    paid: 'Payment accepted',
    waiting: 'Delivering the bundle — it takes a few seconds.',
    granted: 'Bundle delivered ✓',
    grantedHint: 'Consumables are in your wallet, items are in the chest or in the rewards mail.',
    grantedMany: 'Purchases delivered: {n} — earlier payments that had not arrived came through with this one.',
    failedGrant: 'Payment went through, but nothing was delivered',
    failedGrantHint: 'This product is no longer in the shop. Message /paysupport and we will refund the stars.',
    gotTitle: 'Purchase delivered',
    gotNote: 'Consumables are already on your account, the chest is waiting in your storage.',
    gotBox: 'A chest landed in your storage',
    gotBoxNote: 'Opens in {time}. You can wait for free or speed it up with Sands of Time.',
    gotBoxSoon: 'less than a minute',
    gotToChest: 'Go to the chest',
    gotOk: 'Got it',
    slow: 'Paid, the bundle has not arrived yet',
    slowHint: 'Telegram sometimes reports a payment with a delay. The bundle will arrive on its own — check back later, nothing to do.',
    inAppOnly: 'Purchases happen inside Telegram',
    inAppHint: 'Stars are paid inside Telegram: a regular browser simply has no payment window. Open the game in the mini app — same catalogue, same prices.',
    inAppShort: 'in Telegram only',
    openApp: 'Open in Telegram',
  },
  market: {
    consumables: 'Consumables',
    title: 'Market',
    tabBuy: 'Buy',
    tabMine: 'My lots',
    tabSell: 'Sell',
    resShortMat: 'mat.',
    resShortGem: 'gem',
    tabRes: 'Resources',
    tabRent: 'NFT rental',
    resShopNote: 'Materials and small gems for energy. Bigger gems are not sold here — only loot.',
    resShopOff: 'The Resources section is closed right now.',
    tabShop: 'Tools',
    shopNote: 'Craftsmen’s shop: consumables for resources. Fixed prices, the shop is the seller.',
    canBuyNow: 'Available to buy: {n}',
    shopBought: 'Purchased',
    goodsMinutes: '+{n} min of recovery',
    goodsPieces: '{n} pcs',
    goodsDesc: {
      boost_minutes: 'Speed up healing and revival: minutes are cut from the recovery timer.',
      scroll_apprentice: 'Auto-equips the best gear for ONE piece from the chest and its inventory.',
      scroll_master: 'Auto-equips the whole faction in your order: the strongest pick first.',
      hammer: 'Disassembly with materials and gems: one hammer per item in multi-disassembly.',
      ether: 'Recharges a class item: one ether — one charge of any rarity.',
    },
    goods: {
      boost_minutes: 'Sands of Time',
      scroll_apprentice: 'Apprentice scroll',
      scroll_master: 'Master scroll',
      hammer: 'Blacksmith’s hammer',
      ether: 'Ether',
    },
    balance: 'Balance:',
    type: 'Type:',
    category: 'Category:',
    kind: 'Kind:',
    subkind: 'Subtype:',
    rarity: 'Rarity:',
    sort: 'Sort:',
    material: 'Material:',
    size: 'Size:',
    price: 'Price:',
    all: 'All',
    anyF: 'Any',
    anyM: 'Any',
    ammo: 'Gear',
    resources: 'Resources',
    materials: 'Materials',
    gems: 'Gems',
    armor: 'Armor',
    weapon: 'Weapon',
    jewelry: 'Jewelry',
    classItems: 'Class items',
    sortNew: 'Newest',
    sortCheap: 'Cheapest',
    sortExpensive: 'Priciest',
    sortPowerUp: 'Power ↑',
    sortPowerDown: 'Power ↓',
    emptyLots: 'No lots match the filters.',
    emptyRes: 'No resources match the filters.',
    emptyAmmo: 'No gear matches the filters.',
    emptyFilters: 'Nothing matches the filters.',
    buy: 'Buy',
    buyLot: 'Buy lot',
    sell: 'List',
    sellLot: 'List for sale',
    remove: 'Remove',
    itemUnavailable: 'Item unavailable',
    notEnoughEnergy: 'Not enough energy',
    notEnoughRes: 'Not enough resources for this purchase',
    priceLabel: 'Price in energy — min. {min}',
    priceLabelLot: 'Price in energy (for the whole lot) — min. {min}',
    fee: 'Market fee {pct}% — you receive',
    resFee: 'Resource fee: {mats} materials and {gems} gem of the listed amount burn.',
    investedLabel: 'Invested in upgrades:',
    unlockedLabel: 'Upgrade sections:',
    socketsBusy: '{n} filled',
    socketsNone: 'Sockets not punched yet',
    unlockedYes: 'Already paid for by the previous owner',
    unlockedNo: 'Locked — you will have to unlock it yourself',
    commentLabel: 'Comment on the lot (optional)',
    commentHint: 'For example: sharpened for a mage, two empty sockets',
    extraRes: 'Extra payment in resources (optional)',
    addRes: '+ add a resource to the price',
    plusRes: '+ resources:',
    pickRes: '— resource —',
    have: 'have: {n}',
    qty: 'Quantity (have {n})',
    okList: 'Lot listed on the Market.',
    okCancel: 'Lot removed from sale.',
    okBuy: 'Purchase complete — the item is in your chest.',
    errList: 'Could not list the lot.',
    errCancel: 'Could not remove the lot.',
    errBuy: 'Could not buy.',
    rarityShort_common: 'Com.',
    rarityShort_rare: 'Rare',
    rarityShort_super_rare: 'Super',
    rarityShort_unique: 'Uniq.',
    rarityShort_epic: 'Epic',
  },
  skill: {
    precise_strike: 'Precise Strike',
    draining_shot: 'Draining Shot',
    acid_orb: 'Acid Orb',
    cleaver: 'Cleaver',
    knee_breaker: 'Knee Breaker',
    leech: 'Leech',
    zombie_rage: 'Zombie Rage',
    mage_slayer: 'Mage Slayer',
    assassin_arrow: 'Assassin’s Arrow',
    adrenaline: 'Adrenaline',
    mage_ward: 'Mage Ward',
    arcane_armor: 'Arcane Armor',
    ram: 'Ram',
    blessing: 'Blessing',
    guarding_heal: 'Guarding Heal',
    unbreakable_armor: 'Unbreakable Armor',
    cursed_arrow: 'Cursed Arrow',
    forest_curse: 'Curse of the Forest',
  },
  rent: {
    title: 'NFT warrior rental',
    badInput: 'Check the values: term and price must be whole numbers.',
    balance: 'Balance:',
    tabMarket: 'Offers',
    tabOut: 'Rented out',
    tabIn: 'Rented in',
    marketHint: 'The figure comes with its baked gear. Market fee is {pct}%.',
    marketEmpty: 'Nobody is renting out figures right now.',
    outHint: 'Here you can see how much each rented figure has earned and what an early recall costs.',
    outEmpty: 'You have not rented anything out yet.',
    inHint: 'You can play with a rented figure, but its gear belongs to the owner and cannot be changed.',
    inEmpty: 'You have not rented anything yet.',
    owner: 'Owner',
    renter: 'Renter',
    mine: 'This is your figure',
    level: 'Level {n}',
    energyBonus: '+{pct}% energy per kill',
    perDay: '{n} ⚡ per day',
    percentOf: '{pct}% of what the figure earns',
    maxDays: 'Up to {n} days',
    daysLeft: '{n} day(s) left on the shelf — that is the maximum term',
    offerWindow: '{n} day(s) left on the shelf',
    relisted: 'The figure is back and waiting for a new renter.',
    days: 'Days:',
    deposit: 'Charged at once: {n} ⚡',
    noDeposit: 'No deposit: the share comes from what the figure earns.',
    take: 'Rent it',
    takeDone: 'The figure is yours — put it into the squad in «Figure settings».',
    notEnough: '{n} ⚡ short',
    daysWhy: 'Pick a term between 1 and {n} days',
    careCost: 'Heal {heal} ⚡ · revive {revive} ⚡ — paid by the renter',
    waitingRenter: 'Waiting for a renter',
    dayOf: 'Day {n} of {total}',
    gotTotal: 'Received in total: {n} ⚡',
    depositLeft: 'Still on hold: {n} ⚡',
    earned: 'The figure earned: {n} ⚡',
    paidToday: 'Brought since the day started: {n} ⚡',
    recallPrice: 'An early recall costs {n} ⚡',
    recall: 'Recall the figure',
    recallAsk: 'The renter gets {back} ⚡ back, {n} ⚡ of it from your balance. Payments for the days already used stay with you.',
    recallNoMoney: 'You need {n} ⚡ to return, you have {have} ⚡',
    recallPending: 'Recalled — it returns as soon as the renter finishes the match.',
    recalledByOwner: 'The owner recalled the figure — it returns after the match.',
    cancelOffer: 'Remove the offer',
    cancelAsk: 'Remove the offer? The figure stays with you.',
    offerTitle: 'Rent out your figure',
    noRentable: 'Nothing to rent out: you need a healthy NFT figure outside the squad with baked gear.',
    maxDaysField: 'Days on the shelf:',
    maxDaysHint: 'How long the figure stays listed. Within that window it returns to the shelf after every hand-back; when the window ends the offer is removed automatically.',
    kindFix: 'Price per day',
    kindPct: '% of earnings',
    priceField: 'Price, ⚡/day:',
    percentField: 'Share, %:',
    feeNote: 'A {pct}% market fee is taken from every payout.',
    offer: 'Publish',
    offerDone: 'The figure is now on offer.',
    paidByMe: 'Paid: {n} ⚡',
    sharePaid: 'Paid to the owner: {n} ⚡',
    giveBack: 'Return to the owner',
    giveBackAsk: 'Return the figure? The share only comes from earnings, so nothing is lost.',
    noEarlyReturn: 'No early return — you chose the term yourself.',
  },
  stat: {
    physical_damage: 'Phys. dmg', magic_damage: 'Magic dmg',
    physical_resist: 'Phys. def', magic_resist: 'Magic def',
    speed: 'Initiative', dodge: 'Dodge',
    health: 'Health', max_health: 'Max HP', health_regeneration: 'HP regen',
    mana: 'Mana', max_mana: 'Max mana', mana_regeneration: 'Mana regen',
    stamina: 'Stamina', max_stamina: 'Max stamina', stamina_regeneration: 'Stamina regen',
    power: 'Power',
  },
  unit: {
    Pawn: 'Pawn', Knight: 'Knight', Bishop: 'Bishop', Rook: 'Rook', Queen: 'Queen', King: 'King',
    Warrior: 'Warrior', Mage: 'Mage', Archer: 'Archer',
    Elf: 'Elves', Zombie: 'Zombies', ElfGen: 'the Elves', ZombieGen: 'the Zombies',
  },
  ability: {
    charges: 'Charges: {left}/{max}',
    recharge: 'Recharge: {n} rd.',
    regenHp: '{n} to HP regen {suffix}',
    regenMana: '{n} to mana regen {suffix}',
    regenStamina: '{n} to stamina regen {suffix}',
    bridleNote: 'Extra turn at the end of the round (once per battle)',
    bridleDmg: 'Extra attack damage: {pct}%',
    wallNoteRank: 'Places a Wall that blocks the “{rank}” subclass',
    wallNote: 'Places a Wall that blocks an enemy subclass',
    wallStats: 'Wall: {hp} HP, {pct}% defence',
    cloakNote: 'Invisible to enemies (attacks at 50% damage)',
    boardLightningText: '{n} damage to an enemy (never finishes off: 1 HP remains)',
    boardWallNote: 'Places a wall on an empty tile: it cannot be passed or attacked. Also strengthens the Rook itself',
    boardWallRadius: 'The wall tile must be empty, within {n} tile of the Rook',
    boardBridleNote: 'Grants an extra move: you can move twice in a row',
    boardCloakNote: 'The Queen may move but cannot attack; she cannot be attacked and still blocks her tile',
    boardSpellRadius: 'Target — a piece within {n} tile (yourself included)',
    boardSoilNote: 'A zone on any tile of the board. The piece standing on it gains resources on each of its turns: yours with a «+», an enemy with a «−»',
    boardSoilFight: 'If a duel starts on that tile, the zone affects every participant',
    boardSoilAlly: 'Your piece on the tile',
    boardSoilEnemy: 'Enemy piece on the tile',
    soilNote: 'A zone on a tile: allies +regeneration, enemies −. If a duel takes place on that tile, the zone affects EVERY participant',
    spellHealText: '+{n} HP to an ally',
    spellLightningText: '{n} damage to an enemy',
    spellStrengthText: '+{n} to mana/stamina regen of an ally',
    spellWeaknessText: '−{n} to mana/stamina regen of an enemy',
    spellStrengthPair: '+{m} mana regen, +{s} stamina regen of an ally',
    spellWeaknessPair: '−{m} mana regen, −{s} stamina regen of an enemy',
    flaskRow: 'Instantly +{n} health to self',
    flaskRegenRow: '+{n} to health regen for {d} rd.',
    bridleSpeedRow: '+{n} to initiative for {d} rd.',
    bridleDodgeRow: '+{n}% to dodge for {d} rd.',
    wallRow: 'Wall on your tile: {hp} HP, {pct}% defence',
    wallBlockRank: 'Blocks subclass: {rank}',
    wallBlock: 'Blocks an enemy subclass',
    wallBuffHp: 'Rook +{n} max HP while the Wall stands',
    wallBuffRegen: 'Rook +{n} HP regen while the Wall stands',
    wallDuration: 'The Wall lasts {d} rd.',
    cloakRow: 'Invisible to enemies for {d} rd. (attacks at 50% damage)',
    cloakSuffix: '+to self',
    soilRow: 'Tile for {d} rd.: ally +regeneration, enemy −',
    soilSuffix: '±on the tile',
    spellHealRow: '+{n} health to an ally',
    spellLightningRow: '{n} damage to an enemy',
    spellStrengthRow: '+{m} mana regen, +{s} stamina regen of an ally for {d} rd.',
    spellWeaknessRow: '−{m} mana regen, −{s} stamina regen of an enemy for {d} rd.',
    flask: 'Flask',
    bridle: 'Haste',
    spellbook: 'Spells',
    wall: 'Wall',
    cloak: 'Cloak',
    soil: 'Soil',
    pawnDesc: 'Pawn: instantly restores health and grants an HP regen buff for several rounds (on itself).',
    knightDesc: 'Knight: an initiative buff and one extra move at the end of the round (once per battle).',
    bishopDesc: 'Bishop: one of four — Heal, Lightning, Strength, Weakness (on a target/ally).',
    rookDesc: 'Rook: places an obstacle on its half of the field, blocking an enemy subclass; while it stands, the Rook is buffed.',
    queenDesc: 'Queen: invisibility for enemies + all regens; attacks from under the cloak at half strength.',
    kingDesc: 'King: an aura on the tile — allies get +regen, enemies −; works both on the board and in battle.',
  },
  pack: {
    rentedOut: 'Pieces rented out: {n} — they return when the term ends.',
    rentedOutLink: 'View rentals',
    nftOn: 'An NFT warrior stands on this piece',
    nftStanding: 'An NFT warrior is playing',
    // Baked gear: the padlock says "no", these lines say why and what to do about it.
    rentedUnit: 'This figure is rented: only its owner changes the gear. You can still recharge its class item yourself.',
    itemBaked: 'This item is baked into the NFT warrior: it cannot be removed, moved, sold or salvaged. Unlock it in your profile, on the figure card.',
    bakedOnUnit: '🔒 Gear baked into the NFT ({n} items) — unlock it in your profile',
    nftListed: '⚠️ This NFT is listed for sale: the energy bonus is off and its gear went back to the chest',
    nftGone: '⚠️ This NFT is no longer in your wallet — put one of your own pieces in its place',
    nftRemove: 'Remove NFT',
    nftReplace: 'Replace with an NFT warrior',
    nftPickTitle: 'Who replaces {name}',
    nftNoneFit: 'No suitable NFT: it must be the same faction and the same class.',
    nftBusy: 'This NFT already stands in your squad',
    nftBusyShort: 'in use',
    nftLevel: 'lvl {n}',
    nftHint: 'You can replace a piece of the same faction and class. An NFT warrior is a SEPARATE piece with its own gear: the replaced one goes to the reserve with everything it carries and comes back the same.',
    nftAttached: 'The NFT warrior joined your army.',
    nftKeepsGear: 'Gear is not moved: the NFT warrior has its own',
    nftHasGear: 'own gear: {n}',
    bench: 'Reserve',
    benchToSquadHint: 'Drag a reserve figure onto a squad figure of the same class.',
    squadSwapped: 'Squad updated: “{name}” moved to the reserve with its own gear.',
    benchNote: 'In reserve: it does not play and is skipped by auto-equip, but its items stay available',
    benchMoved: '“{name}” moved to the reserve with all of its gear.',
    nftRemoved: 'The NFT warrior moved to the reserve, your own piece is back in the squad.',
    rechargeEther: 'With ether ({n})',
    rechargeEtherHint: 'Restore charges with ether: 1 ether = 1 charge',
    tipAutofillUnit: 'Auto-equip the best gear on this piece (apprentice scrolls: {n})',
    tipAutofillFraction: 'Auto-equip the best gear across the faction (master scrolls: {n})',
    autofillDone: 'Auto-equip: {n} items changed',
    autofillNothing: 'Nothing to improve — the scroll was not spent',
    autofillSkipped: 'Wounded pieces skipped: {n} — heal them first',
    orderWounded: 'A wounded piece cannot be equipped — heal it first',
    boostTitle: 'Boost minutes (you have: {have})',
    boostApply: 'Speed up',
    orderTitle: 'Autofill queue',
    orderNote: 'Click the pieces — the scroll equips them in that order (whoever is first takes the best).',
    orderPicked: 'Pieces selected: {n} — the rest are left as they are',
    orderAll: 'Nothing selected — the whole faction is equipped in the default order',
    orderApply: 'Use the scroll',
    orderReset: 'Clear selection',
    mainStatTitle: 'Main stat of the run',
    mainStatHint: 'The scroll builds the set around “{stat}” — the other stats follow in the usual order.',
    mainStat: {
      health: 'Health',
      dodge: 'Dodge',
      speed: 'Initiative',
      resist: 'Resistance',
      health_regeneration: 'Health regen',
      resource_regeneration: 'Mana/stamina regen',
      resource: 'Mana/stamina',
      damage: 'Damage',
    },
    boostBuyAt: 'Sands of Time are sold in the shop on the Market',
    boxNameRarity: '{rarity} chest',
    boxNamePlain: 'Chest',
    boxNameDay: '{day} chest',
    boxNameExtra: '{name} (extra)',
    boxNameWeek: 'Weekly chest',
    boxNameMonth: 'Monthly milestone chest',
    boxPromise: 'Inside: an item of level {level}',
    boxReady: 'ready',
    boxReadyNote: 'The chest is ready to open',
    boxOpensIn: 'Opens in {time}',
    boxOpen: 'Open',
    boxBoost: 'Open now for {n} sand',
    boxNoSands: 'Not enough Sands of Time — you can simply wait for the timer',
    boxLootTitle: 'The chest contained',
    boxLootOk: 'Great',
    boostDone: 'Recovery sped up',
    itemDesc: 'Item description',
    pieceInfo: 'Piece information',
    inventory: 'Inventory',
    storage: 'Ammunition storage',
    levelTooLow: 'Level {level} gear — the piece needs level {need} or higher',
    title: 'Piece Settings',
    desk: '← Tournament menu',
    findOpponent: 'Find opponent',
    waitingStart: 'Waiting for the tournament to start…',
    tourNotStarted: 'The tournament has not started yet',
    surrender: 'Surrender',
    returnToMatch: 'Return to match',
    surrenderConfirm: 'Surrender the current match?',
    chooseUnit: 'Select a piece',
    hoverItem: 'Hover/click an item',
    stats: 'Stats:',
    noBonuses: 'no bonuses',
    minLevel: 'Min. lvl: {n}',
    opensAbility: 'Unlocks ability:',
    activeSkills: 'Active skills',
    abilityCharges: 'Ability charges',
    classAbility: 'Class ability',
    equip: 'Equip',
    unequip: 'Unequip',
    sell: 'Sell',
    disasm: 'Disassemble',
    disasmHammer: '🔨 Disassemble with a hammer ({n})',
    disasmHammerNone: '🔨 Disassemble with a hammer (none left)',
    // SHARPENING (docs/SHARPENING_PLAN.md). Price and chance come FROM THE SERVER and are printed
    // as is — the screen keeps no copy of the formulas, it would drift from the config silently.
    sharpen: '⚒️ Upgrade',
    sharpenTitle: 'Sharpening',
    sharpenNote: 'Sharpening raises ONE stat by a step. On a failure the reagents burn, the item stays intact.',
    unlockSharpen: 'Sharpening is not unlocked for this item yet',
    unlockReplace: 'Transformation is not unlocked for this item yet',
    unlockNote: 'Access is bought once. After that attempts cost only resources and scrolls.',
    unlockGo: 'Unlock the section',
    sharpenHaveShort: 'You have:',
    sharpenStep: 'step {n} of {max}',
    sharpenChance: 'chance {p}%',
    sharpenPity: '+{p}% for failures ({n})',
    sharpenGo: 'Sharpen',
    sharpenMaxed: 'This stat is sharpened to its limit',
    sharpenCapped: 'This stat has hit the item cap — there would be no gain',
    sharpenCappedAt: 'The stat hit this item’s cap ({cap}%) — sharpening adds nothing',
    sharpenMissing: 'Not enough: {list}',
    // Bulk selection in the storage: batch salvage and batch chests (owner's request 2026-09-01)
    pickItems: 'Items selected: {n}',
    pickBoxes: 'Chests selected: {n} (ready: {ready})',
    pickAll: 'Select all',
    pickCancel: 'Clear',
    disasmFree2: 'Disassemble ({n})',
    disasmWithHammer: 'With hammer ({n})',
    boxPickStart: 'Select chests: open or speed up in one go',
    boxPickCancel: 'Leave chest selection',
    boxOpenAll: 'Open ({n})',
    boxBoostAll: 'Speed up all ({n} min)',
    boxBatchMax: 'No more than {n} chests at a time',
    boxBoostedAll: 'Sped up, sand spent: {n} min',
    boxBoostedPartly: 'Not enough sand for everything: {n} min spent',
    boxBoostPartly: 'You have {have} min of sand out of {need} needed — we will speed up what we can',
    sharpenIfAll: 'if all {n} succeed',
    sharpenMax: 'max',
    sharpenPlanned: 'Attempts planned: {n} of {max}',
    sharpenRunAll: '⚒️ Sharpen all',
    pickHint: 'hold an item or chest to select several',
    itemSharpened: '✨ Sharpened: +{n} steps above the rolled ones',
    itemSocketed: '💎 Gems set: {n} of {max}',
    // SOCKETS (stage E4): a socket is punched with a chisel; the gem grants stats by kind and size
    socketsTitle: 'Gem sockets',
    socketsPunched: '{n} of {max} punched',
    socketsNote: 'Sockets are punched with a chisel in ONE roll, once per item: how many you get is up to luck. The gem you set grants stats by its kind and size.',
    socketOpen: 'Punch sockets',
    socketOdds: 'Roll chances (sockets opened):',
    socketReroll: 'Reroll the sockets',
    socketRerollGo: 'Reroll',
    socketRerollWarn: 'The sockets are rolled again and there may be FEWER of them than now. This cannot be undone.',
    socketRerollGems: 'Remove the gems first: a reroll rolls the sockets again.',
    socketEmpty: 'Empty socket',
    socketChoose: 'Which gem to set:',
    socketNoGems: 'You have no suitable gems.',
    socketExtract: 'Remove the gem',
    socketExtractBurn: 'Removing burns the gem; the socket stays empty.',
    socketExtractBack: 'The gem returns to your stock; the socket stays empty.',
    socketCatTitle: 'What gems grant in this item:',
    socketExtractFree: 'Removal is free.',
    itemPower: 'Item power',
    socketClassOnly: 'Class items only: {list}. In ordinary gear a gem does not grant them.',
    improveTitle: 'Gear upgrade',
    tabSharpen: 'Sharpening',
    tabReplace: 'Transformation',
    tabSockets: 'Sockets',
    replaceNote: 'Transformation swaps a stat for another random one. It always works; {keep}% of the steps carry over.',
    replaceNone: 'This item has no stats that can be swapped: permanent ones define what the item is.',
    replaceKeeps: 'steps kept: {n}',
    replaceOdds: 'Chance of each stat:',
    socketNoneYet: 'No sockets yet — punch them with a chisel.',
    socketOpened: 'Sockets punched: {n}',
    socketRerolled: 'Reroll: {was} before, {n} now',
    socketInserted: '{gem} set',
    socketBurned: 'Gem removed and burned ({gem})',
    socketTakenBack: 'Gem removed and returned to your stock ({gem})',
    replaceGo: 'Replace',
    replaceAsk: 'Replace “{stat}” with another random stat? This cannot be undone, and {keep} of {steps} steps will remain.',
    replacePick: 'Wanted stat:',
    replaceAny: 'Any (single swap)',
    replaceTries: 'Attempts:',
    sharpenNotAll: 'Not enough for every attempt: {list} — the server stops when they run out.',
    spendTotal: 'Will spend:',
    replaceUpTo: 'Will spend at most:',
    replaceRunAuto: 'Roll for it',
    replaceHit: 'Rolled {stat} in {n} attempt(s)',
    replaceMiss: '{stat} did not come up in {n} attempt(s)',
    replaceConfirm: '🔮 Replace the stat',
    replaceDone: 'Stat replaced: “{from}” → “{to}”',
    sharpenSummary: 'Attempts: {n}, successful: {ok}. The item is intact — failures only burned reagents.',
    sharpenStepShort: 'step {n}',
    statPermanent: 'Permanent stat: can be sharpened, but never replaced',
    spentTotal: 'Invested in this item:',
    sharpenSpent: 'Spent:',
    sharpenOutOfReagents: 'Ran out of reagents — stopped here',
    sharpenOff: 'Sharpening is unavailable right now.',
    sharpenNone: 'This item has no stats that can be sharpened.',
    sharpenLocked: 'Only gear of a healthy figure can be sharpened, and only outside a match.',
    disasmEnergyRange: '⚡ Energy, guaranteed: {min}–{max}',
    disasmRefund: 'This item has upgrades — {min}% to {max}% of what you spent on them comes back.',
    disasmRefundBack: 'Returned from upgrades ({pct}%):',
    disasmRefundBackAny: 'Returned from upgrades:',
    disasmConfirm: 'Disassemble the item?',
    disasmBatchConfirm: 'Disassemble the selection — {n} item(s)?',
    disasmBatchHammer: 'Hammers to spend: {n}. A hammer also yields materials and gems.',
    disasmBatchTop: 'The selection includes a {r} item — this cannot be undone.',
    disasmFree: 'Disassembly is free',
    disasmResult: 'Disassembled! You got:',
    disasmNothing: 'Nothing dropped this time.',
    disasmNoData: 'No disassembly data for this item.',
    disasmSelected: 'Disassemble selected (hammers to spend: {n})',
    disasmCancel: 'Cancel disassembly',
    disasmQuick: 'Multi-disassembly with hammers (you have {n}): 1 hammer per item. Press 🔨, select the items and press 🔨 again. Unlike the plain one it also yields materials and gems, not just energy',
    disasmBatchMax: 'Up to {n} items can be broken down at once',
    disasmLockedItem: 'This item is locked right now — it cannot go into a batch',
    disasmSharpenedItem: 'A sharpened item is not taken into a batch — break it down one by one',
    disasmSocketedItem: 'This item has sockets — break it down one by one to get the gems back',
    disasmChestOnly: 'The hammer only breaks down items from the storage — move the item there first',
    disasmLimit: 'Your hammers cover only {n} item(s) — buy more at the Market',
    withHammer: 'With a blacksmith’s hammer (1 hammer per item):',
    disasmNoHammer: 'A blacksmith’s hammer is required — buy one at the Market (Boosts tab)',
    disasmOnlyEnergy: 'Without a hammer only energy drops. Materials and gems come from hammer disassembly.',
    disasmGuarantee: 'Disassembly is never empty: if the roll fails you still get the minimum — energy one by one, materials with a hammer.',
    dropAlways: 'always',
    youGet: 'You will get:',
    emptySlot: 'Empty — drag an item here from the piece inventory',
    ok: 'OK',
    cancel: 'Cancel',
    recharge: '⚡ Recharge',
    rechargeItem: '⚡ Recharge ({price}/charge)',
    rechargeHint: '{price}⚡ per charge; if energy runs out we restore as much as possible',
    rechargeFrac: 'Recharge class items of {fraction}?',
    rechargeTotal: 'Total: {total}⚡ · balance {balance}⚡',
    rechargeEtherAll: 'Or with ether: up to {n} charges (ether: {ether})',
    rechargeEtherAllBtn: 'Recharge with ether ({n})',
    rechargeRow: '+{n} chg · {price}⚡',
    rechargeNotEnough: 'Not enough energy for everything — we will recharge what we can.',
    rechargeAllFull: 'All class items of this faction are fully charged.',
    rechargeDone: 'Class items recharged',
    chargesRestored: 'Charges restored',
    healAll: '✚ Restore all',
    healFrac: 'Restore the pieces of {fraction}?',
    healTotalCost: 'Total cost to restore everyone:',
    healBalance: 'Energy balance: {balance}⚡. If resources run short, we restore whoever we can.',
    healFree: 'Restoration is free (timers have expired).',
    healBoostHint: 'Sands of time: {n} min in stock — they rewind the timers of the whole side',
    healTotalTime: 'Full restore with sands: {n} min',
    healBoostAll: 'Speed up with sands',
    hospitalHint: 'Full army healing: {n} left — restores EVERY figure of both sides at once',
    hospitalUse: 'Heal the army',
    hospitalDone: 'Army restored: {n} figures',
    healBoostDone: 'Ready: {n} · minutes spent: {m}',
    healUnit: 'Heal the piece?',
    reviveUnit: 'Revive the piece?',
    heal: 'Heal',
    revive: 'Revive',
    healed: 'Healed',
    revived: 'Revived',
    unitsRestored: 'Pieces restored',
    unitsRestoredPart: 'Restored {done} of {total} — not enough resources for the rest',
    unitsRestoreNone: 'Not enough resources to restore',
    freeIn: 'Free in {time}',
    instantFor: 'Instantly for:',
    matchInProgressAmmo: 'Match in progress — gear cannot be changed',
    matchInProgressHeal: 'Match in progress — restoring is unavailable',
    matchFinished: 'Match finished',
    unitDeadAmmo: 'The piece is dead — gear is locked until revival',
    unitDeadInv: 'The piece is dead — inventory is locked',
    unitWounded: 'The piece is wounded — heal it first',
    restoreFirst: 'Restore the piece first',
    notForThisUnit: 'Not suitable for this piece',
    swapSameType: 'Only pieces of the same type can be swapped',
    unitsSwapped: 'Pieces swapped',
    swapFractionsTitle: 'Gear swap',
    swapFractions: 'Swap all gear between Elves and Zombies?',
    swapFractionsOk: 'Swap',
    fractionsSwapped: 'Faction gear swapped',
    inventoriesUnloaded: 'Inventories unloaded to the chest',
    notEnoughEnergyRecharge: 'Not enough energy to recharge',
    error: 'Error',
    energyToBalance: 'Energy (to balance)',
    energyFromBalance: 'Energy (from balance)',
    energy: 'energy',
    material: 'Material (wood/stone/iron)',
    gemLine: 'Gem ({size})',
    dropNote: 'Each line drops independently; the material and gem types are random.',
    tipBalance: 'Energy balance: spendable (disassembly, healing). Refilled with energy from matches',
    tipHasBox: 'A loot chest is waiting in this figure inventory',
    tipHasAmmo: 'There is gear in the inventory',
    tipUnload: 'Unload gear from all piece inventories into the chest',
    tipSell: 'List on the Market for energy',
    tipHealAll: 'Revive/heal all wounded and fallen pieces of the faction',
    tipRechargeAll: 'Recharge all class items of the faction',
    tipSwapFractions: 'Swap all gear between factions',
    tipUnequipAll: 'Unequip all gear into the inventory',
    tipToChest: 'Put everything into the chest',
    weapon: 'Weapon',
    shieldQuiver: 'Shield/Quiver',
    classItem: 'Class item',
    spellbookItem: 'Spellbook',
    cloakItem: 'Cloak of invisibility',
    player: 'Player',
    levelShort: 'lvl',
  },
  game: {
    charges: 'Charges: {left}/{max}',
    recharge: 'Recharge: {n} r.',
    regenHp: '{n} to HP regen {suffix}',
    regenMana: '{n} to mana regen {suffix}',
    regenStamina: '{n} to stamina regen {suffix}',
    roundsShort: 'r',
    errorCode: 'Error {code}',
    costMana: '{n} mana',
    costStamina: '{n} stamina',
    costHealth: '{n} HP',
    costLabel: 'Cost: {parts}',
    stats: 'Stats:',
    noBonuses: 'no bonuses',
    noData: 'no data',
    minLevel: 'Min. lvl: {n}',
    opensAbility: 'Unlocks ability:',
    abilityCharges: 'Ability charges',
    equipment: 'Equipment',
    backpack: 'Backpack',
    history: 'Move history',
    logSkip: 'pass',
    piece: {
      King: 'K', Queen: 'Q', Rook: 'R', Bishop: 'B', Knight: 'N', Pawn: '',
    },
    fullscreen: 'Fullscreen',
    classicFigures: 'Classic pieces',
    styledFigures: 'Stylised pieces',
    viewFrom: 'View from the {side} side',
    sideElf: 'elves',
    sideZombie: 'zombies',
    hoverUnit: 'Hover a piece',
    level: 'Level {n}',
    power: 'Power',
    buffs: 'Buffs',
    debuffs: 'Debuffs',
    inventory: 'Inventory',
    whatSkill: 'What the skill does',
    whatAbility: 'What the ability does',
    soilDrains: 'The Soil under your king drains mana at the start of the turn — not enough for the skill',
    soilAnnihilated: 'The two Soils clashed and annihilated each other — the cell is cleared',
    castImmune: 'The enemy king and queen are immune to magic — pick another enemy piece',
    techDefeatIn: 'Technical defeat in:',
    techDefeatOppIn: "Opponent's technical defeat in:",
    selfPlayNoReward: 'Playing against yourself — no rewards are granted',
    armyNotReady: 'Your army is not restored yet — heal the pieces in Army setup',
    waitingOpponent: 'Waiting for an opponent',
    resWin: 'Victory!',
    resLose: 'Defeat',
    resDraw: 'Match over',
    resWinnerIs: '{side} won',
    resWinnerLine: '{side} · {name}',
    resNoWinner: 'No winner',
    resYou: 'you',
    resWinnerTag: 'Winner',
    resKilled: 'Pieces taken',
    resEnergy: 'Energy this match',
    resRating: 'Rating',
    lootTitle: '🎁 Your loot for the match',
    lootSide: '🎁 Loot: {side}',
    lootEmpty: 'No loot dropped in this match',
    fightResult: 'Battle result',
    surrender: 'Surrender',
    surrenderConfirm: 'Surrender? This match will count as a loss.',
    toLobby: 'To lobby',
    exit: 'Exit',
    spectator: '👁 Spectator',
    spectatorsWatch: 'Spectators watching',
    like: 'Send a like',
    close: 'Close',
    chooseCell: 'choose a tile',
    chooseTarget: 'choose a target',
    chooseSpell: 'choose a spell',
    itemLost: 'Item lost (inventory full)',
    dropBox: 'A {rarity} chest — waiting in the figure inventory',
    noQueue: 'Unfortunately there are no players in the queue right now.',
    noQueueHint: 'Try switching factions or enabling a bot.',
    promotePawn: 'Promote the pawn into a fallen ally',
    decideLater: 'Decide later',
    protection: 'Defence',
    miss: 'Miss',
    perRound: 'r.',
    perTurn: 'r./turn',
    duration: 'Duration: {n} {unit}',
    dispel: 'Removes enemy spells from the target — together with the buff they grant the enemy',
    self: 'Self',
    target: 'Target',
    spellHeal: 'Heal',
    spellLightning: 'Lightning',
    spellStrength: 'Strength',
    spellWeakness: 'Weakness',
    spellCleanse: 'Cleanse',
    spellVampirism: 'Vampirism',
    gem: 'Gem',
    gemSmall: 'small',
    gemMedium: 'medium',
    gemLarge: 'large',
  },
  shop: {
    itemLine: '{rarity} item (lvl {level})',
    title: 'Gear shop',
    empty: 'The shop is empty.',
    balance: 'Energy balance:',
    buy: 'Buy · {price} ⚡',
    note: 'A random item of the chosen rarity for your piece level drops — into the chest.',
    got: 'Received:',
    lost: 'item lost (storage full)',
    errBuy: 'Could not buy.',
  },
  res: {
    topaz: 'Topazes',
    ruby: 'Rubies',
    sapphire: 'Sapphires',
    diamond: 'Diamonds',
    topazOne: 'topaz',
    rubyOne: 'ruby',
    sapphireOne: 'sapphire',
    diamondOne: 'diamond',
    wood: 'Wood',
    stone: 'Stone',
    iron: 'Iron',
    woodOne: 'wood',
    stoneOne: 'stone',
    ironOne: 'iron',
    sizeS: 'Small',
    sizeM: 'Medium',
    sizeL: 'Large',
    sizeU: 'Unique',
    sizeLeg: 'Legendary',
    sizeSlow: 'small',
    sizeMlow: 'medium',
    sizeLlow: 'large',
    sizeUlow: 'unique',
    sizeLeglow: 'legendary',
  },
  // ─── Help screen (the menu item after the tutorial): topics + replay an act ───
  help: {
    title: 'Help',
    subtitle: 'How everything works — and how to replay any part of the tutorial',
    restartTitle: 'Take the tutorial again',
    restartHint: 'Start the whole guide from the very beginning — the mentor will walk you through every step again. Great for long-time players too. Rewards for parts already done will not repeat. You can start over only once.',
    restartBtn: 'Start over',
    restartUsed: 'You have already used this — the tutorial can be started over only once. Replaying a single part below has no limit.',
    replayTitle: 'Replay the tutorial',
    replayHint: 'Pick a part and the mentor will walk you through it again. Its rewards are already granted and will not repeat.',
    wikiTitle: 'Detailed wiki',
    wikiHint: 'Full tables of items, skills and formulas live in the project wiki.',
    topic: {
      board: {
        title: 'The board',
        l1: 'Pieces move like in chess, but a capture starts a duel — the winner takes the square.',
        l2: 'The goal is to kill the enemy king, not to checkmate.',
        l3: 'There are two clocks: one for the whole match and a short one per move. Run out and the move is lost.',
        l4: 'The king casts right from the board without moving.',
        l5: 'Wounded pieces do not heal on their own — restore them in «Figure settings».',
      },
      fight: {
        title: 'The duel',
        l1: 'A 4×4 grid: warriors go in front, archers and mages hide behind them.',
        l2: 'Only warriors reach the front line; archers and mages can hit any row.',
        l3: 'Turn order follows initiative — the queue ribbon is on the left.',
        l4: 'A plain attack costs nothing: warrior skills spend stamina, mage skills mana, archer skills both.',
        l5: 'A class item grants an ability and spends a charge — charges are refilled with energy or ether.',
      },
      army: {
        title: 'Your army',
        l1: 'Every piece has a subclass — Warrior, Archer or Mage — and gear is picked to match it.',
        l2: 'Gear in the chest does nothing: only equipped items raise power.',
        l3: 'Army power is the sum of your pieces, and opponents are matched by it.',
        l4: 'Scrolls equip gear for you: an apprentice scroll for one piece, a master scroll for the whole side.',
        l5: 'A piece inventory and the shared chest are different places — loot is unloaded with one button.',
      },
      economy: {
        title: 'Economy',
        l1: 'Energy is your rating; what you spend is the balance earned on top of it.',
        l2: 'Materials and gems come from dismantling gear and from daily quests.',
        l3: 'Healing and revival cost resources and time; sands of time rewind the timer.',
        l4: 'The blacksmith hammer powers multi-dismantling — that is what brings materials and gems.',
        l5: 'Spare gear is sold to other players on the market for energy.',
      },
      meta: {
        title: 'Competition',
        l1: 'Daily quests give a chest for 100 points, and a streak of days gives the weekly chest.',
        l2: 'The wheel of fortune spins for tickets: quests, friends and the shop provide them.',
        l3: 'Power tolerance decides how evenly matched your opponent will be.',
        l4: 'A tournament uses a separate profile: its own army and table, your pieces are not carried over.',
        l5: 'Invited friends bring tickets, and other players’ matches can be watched in spectator mode.',
      },
    },
  },
  tut: {
    tag: 'Tutorial',
    hide: 'Hide hint',
    hideHint: 'Hide the hint',
    act0: 'Into the world',
    act1: 'First match',
    stepOf: 'step {n} of {total}',
    stopOf: 'stop {n} of {total}',
    next: 'Next',
    gotIt: 'Got it',
    skip: 'Skip',
    skipAll: 'Skip the tutorial',
    tourDone: 'To my army',
    mentorElf: 'Faniluana, your mentor',
    mentorZombie: 'Undead Queen, your mentor',
    buttonActive: 'Tutorial',
    buttonResume: 'Resume tutorial',
    buttonHelp: 'Help',
    lockedHint: 'opens after your first match',
    factionTitle: 'Choose your side',
    factionSub: 'Your side is the army you build',
    factionElf: 'Alive and swift. Move first more often, heal allies and strike true.',
    factionZombie: 'Dead and tough. Soak damage, weaken the enemy and win by numbers.',
    factionSay: 'Welcome. Pick a side — and I will show you how battles are won here.',
    chosen: 'chosen',
    playAs: 'Play as {side}',
    giftTitle: "Mentor's gift",
    giftSub: 'Two items you will use in your very first battle',
    giftSay: 'These are not trinkets. In a duel they grant abilities — let us equip them.',
    giftFor: 'worn by {unit}',
    giftNext: 'Show me the game',
    tourPvp: 'This is where matches against live players begin.',
    tourTournaments: 'Separate competitions with an equal start for everyone.',
    tourLearn: 'Come back here any time to continue the tutorial.',
    equipHint: 'Drag the gift into the highlighted slot — it is the class item slot.',
    equipDone: 'Equipped! The piece got stronger — time to fight.',
    hintSelect: 'Tap a piece to see where it can move',
    hintTimer: 'Every move is timed. Too slow — the move is lost',
    hintAttack: 'Attack an enemy piece — a duel will start',
    hintAfterFight: 'Wounded pieces do not heal on their own — heal them in Piece Settings',
    hintWin: 'The goal is to kill the enemy king',
    // ─── Act 2 «Your army» ───
    act2: 'Your army',
    later: 'Later',
    armyChestTitle: 'Storage',
    armyChest: 'An item in the chest does nothing until you wear it',
    armyEquipTitle: 'Equipment',
    armyEquip: 'Drag the loot into a slot — the figure gets stronger',
    armyHealTitle: 'Healing',
    armyHeal: 'The wounded never heal by themselves. Press ⛑ and get your army back on its feet',
    armyResTitle: 'Resources',
    armyRes: 'Materials and gems come from disassembly and daily quests',
    armyDisasmTitle: 'Disassembly',
    armyDisasm: 'Spare gear turns into resources. The hammer gives more',
    armyWheelTitle: 'Wheel of fortune',
    armyWheel: 'The ticket is already yours — give it a spin. The wheel drops resources and gear up to epic; tickets come from daily quests, friends and the shop',
    // ─── «Newbie path» checklist ───
    pathTitle: 'Newbie path',
    pathClaim: 'Claim',
    pathGot: 'Received:',
    pathDone: 'A «Newbie path» goal is done — the reward waits in your profile',
    // ─── second tutorial pass (2026-07-29) ───
    equipBridleHint: 'Drag the Bridle into the knight’s golden slot — it grants an extra turn in a duel',
    pickFigureTitle: 'Pick a figure',
    pickPawn: 'Tap this pawn — the Flask goes to it',
    pickKnight: 'Now the knight: tap it, the Bridle is his',
    swapTitle: 'Centre of the line-up',
    swapHint: 'Drag the pawn with the Flask onto {cell} — to the centre of your row. Figures simply swap places',
    swapDone: 'The pawn with the Flask is in the centre',
    dailyOpenTitle: 'Daily quests',
    dailyOpen: 'Daily quests open from here, from the profile — remember the way, you will come back every day',
    dailyOpenGo: 'Open the quests',
    dailyTitle: 'Daily quests',
    dailyHint: 'New quests every day and a chest for 100 points. Claim your first reward — and off to battle',
    toBattle: 'To battle',
    dailyAfter: 'The match counted towards the quests. Claim the rewards — and back to the army',
    dailyClaimFirst: 'Claim the rewards',
    toPack: 'To figure settings',
    pvpToBattleTitle: 'To battle!',
    pvpToBattle: 'Everything is ready. Press «To battle» — I will find you an opponent and stay with you through the match',
    pvpToPackTitle: 'Get your army in order',
    pvpToPack: 'After the battle your figures are wounded. Open «Figure settings» — we will heal the army and sort out the loot',
    pvpLock: 'First match is played as {side}: your mentor’s gift is on those figures',
    tourInGame: 'look around the match',
    armyUnloadTitle: 'Loot in the bags',
    armyUnload: 'After a match the loot sits in figures’ bags. The ▼ button moves everything to the shared chest',
    armyRechargeTitle: 'Recharging',
    armyRecharge: 'The ⚡ button recharges class items: charges are spent in battle, and without them the ability will not fire. Pay with energy or ether. Recharge one — and take the reward',
    armySwapTitle: 'Swap between factions',
    armySwap: 'The ⇄ button swaps gear between your elves and zombies — one army hands its equipment to the other. Swap them — and take the reward',
    mktTabsTitle: 'Market',
    mktTabs: 'This is where players trade with each other. Four tabs: «Buy», «My lots», «Sell» and «Shop». Let us walk through each',
    mktBuyTitle: 'Buy',
    mktBuy: 'Here are other players’ lots. Filters and sorting at the top narrow the search. The price is in energy ⚡ (sometimes with an extra resource cost); the «Buy» button takes the lot',
    mktSellTitle: 'List for sale',
    mktSell: 'You can sell gear and resources for energy. Only gear from a figure’s inventory, the common chest or the reward storage can be listed — take off equipped items first. Tap an item, set a price — and the lot is on the market',
    mktMineTitle: 'My lots',
    mktMine: 'Your active sales. The «Remove» button pulls a lot from the market and returns the item to you',
    mktShopTitle: 'Shop',
    mktShop: 'Here boosts (sands of time, autofill scrolls) are sold by the game itself — for resources, not energy',
    mktWarnTitle: 'Play fair',
    mktWarn: '⚠️ The market is watched: reselling to yourself and any price manipulation are punished — your account can be blocked',
    armyHealWays: 'There are two ways to heal: pay with resources and energy — the figures are back at once, or speed recovery up with sands of time',
    // ─── Act 3 «The daily loop» (second visit) ───
    act3: 'The daily loop',
    day2WelcomeTitle: 'Welcome back',
    day2Welcome: 'Coming back every day pays off: here is a wheel ticket. Let me show you what a game day is made of',
    day2ToDaily: 'To daily quests',
    day2StreakTitle: 'Streak and week',
    day2Streak: 'Every day with quests extends your streak, and 5 days out of 7 give the weekly chest and raise your reward tier',
    day2ToWheel: 'To the wheel',
    day2WheelTitle: 'Wheel of fortune',
    day2Wheel: 'You already have a ticket — give it a spin. Tickets come from quests, friends and the shop',
    // ─── Act 4 «Competition» ───
    act4: 'Competition',
    compDevTitle: 'Power tolerance',
    compDev: 'A narrow tolerance means an opponent of your exact power but a longer search. A wide one is faster but tougher',
    compBoardTitle: 'Leaderboard',
    compBoard: 'Your rating is the energy you have earned. The eye next to a name opens that player’s army',
    compSpectateTitle: 'Spectator mode',
    compSpectate: 'Live matches are listed here: watch them and learn from the strong',
    compSeasonTitle: 'Tournaments',
    compSeason: 'A tournament has a separate profile: its own army and its own table. Your figures are NOT carried over',
    compRefTitle: 'Invite friends',
    compRef: 'Every friend brings you wheel tickets. The link above is yours forever',
    compDone: 'Done',
    profileTitle: 'Profile',
    profileOpen: 'Tap «Profile» — the rest I will tell you inside',
    profileGo: 'Open the profile',
    profileTourTitle: 'What is in the profile',
    profileTour: 'Rating and resources, daily quests, the wheel, the market and «Figure settings». Let us go to the settings and dress the army',
    profileToPack: 'To figure settings',
    waitTitle: 'Waiting for an opponent',
    waitFullscreen: 'While we look for an opponent — go fullscreen, it is far more convenient',
    gamePickTitle: 'Select a figure',
    gamePick: 'Tap the pawn with the Flask — then the «Backpack» will show its gear',
    tourInFight: 'duel',
    fightStandTitle: 'Line-up',
    fightStand: 'Warriors go to the front row — only they take the hit. Hide archers and mages behind them',
    fightOrderTitle: 'Turn order',
    fightOrder: 'The ribbon on the left is the queue: the higher the initiative, the sooner a figure acts',
    fightHitTitle: 'An attack ends the turn',
    fightHit: 'A turn ends with an attack, a defence or the clock. Attack an enemy figure',
    fightSkillTitle: 'Skills and abilities',
    fightSkill: 'A skill and a class ability do NOT cost a turn — use them before attacking. The «i» button shows the details',
    fightAbilityTitle: 'Gift ability',
    fightAbility: 'This figure has an item ability — use it, it costs no turn',
    kingCastTitle: 'King’s cast',
    kingCastPick: 'Tap your king — he can cast right on the board',
    kingCastPickFoe: 'Tap your king — he can cast right on the board. The spell hits an enemy, but the enemy king and queen are immune to magic',
    kingCast: 'Here is the skill button on the «Sword» tab. Press it and pick a target — the cast is your move. The king skill cannot target the enemy king or queen (they are immune to magic on the board)',
    tourFiguresTitle: 'Figures with the gift',
    tourFigures: 'Here they are: the pawn with the Flask and the knight with the Bridle. In a duel they gain abilities',
    tourPackTitle: 'Backpack',
    tourPack: 'The backpack shows equipped gear and the piece inventory — 14 cells. Fill it up and this piece stops collecting trophies',
    tourSwordTitle: 'Sword',
    tourSword: 'The sword tab shows the stats, and below it the buffs and debuffs on the piece with rounds left',
    tourTimersTitle: 'Two timers',
    tourTimers: 'The match clock and the turn clock. While you read a hint, both are paused',
    tourEnergyTitle: 'Side energy',
    tourEnergy: 'The side icons are on top — the lit one shows whose turn it is. Next to each is its energy counter: what the side earned for kills. Energy is your rating',
    tourMiniTitle: 'Mini board',
    tourMini: 'The whole position is below, and the button above it switches the look of the figures',
    gameDefendersTitle: 'Who joins the fight',
    gameDefenders: 'When you attack a piece, not only it but ALL its defenders join the duel. Select your piece — the cells of everyone who could join the duel are highlighted in orange. Always watch the defenders: attacking a piece guarded by several defenders is risky.',
    rollTitle: 'Reward for the step',
    rollSub: 'Roulette roll',
    rollGot: 'Received: {reward}',
    path: {
      win_pvp: 'Win a match',
      equip_5: 'Equip 5 items',
      heal_unit: 'Heal a figure',
      disassemble: 'Disassemble an item',
      daily_chest: 'Claim the daily chest',
      market_visit: 'Explore the market',
      market_sell: 'List a lot on the market',
      wheel_spin: 'Spin the wheel of fortune',
      invite_friend: 'Invite a friend',
    },
    helpTitle: 'How to do it',
    pathHelpHint: 'Tap — the mentor will show where it is done',
    help: {
      win_pvp: 'Pick a side and press «Start». The item closes on a win over a player or a hard bot (an easy bot does not count)',
      equip_5: 'Open the chest and drag items into the figure slots. Five items in total',
      heal_unit: 'The ⛑ button next to your army: pay with resources or speed recovery up with sands of time',
      disassemble: 'The 🔨 button scraps spare gear into resources. One hammer — one item',
      wheel_spin: 'Press «Spin»: tickets come from daily quests, friends and the market shop',
      daily_chest: 'Collect 100 points from daily quests — the chest opens by itself, claim the reward here',
      market_visit: 'Just open the market — the mentor will show you around',
      market_sell: 'The «Sell» tab: pick an item or resource, set the price in energy and list it',
      invite_friend: 'Copy your link and invite a friend — their first match brings you tickets',
    },
  },
  daily: {
    doneInMatch: 'completed',
    doneClaimed: 'completed · reward taken',
    readyTake: 'completed — claim the reward',
    rewardQuest: 'Quest reward',
    rewardChest: 'Chest loot',
    rewardNote: 'Everything is already credited — items are in your chest and on pieces',
    rewardNotePick: 'Pick your item — it and the rest of the reward travel as one chest',
    pickWaiting: 'Waiting for your choice',
    rewardOk: 'Take',
    peekNote: 'What this day’s chest holds',
    inMail: 'waiting in mail',
    boxNote: 'It is in your storage and opens in {time}',
    openChest: 'Open the daily chest',
    later: 'Later',
    ok: 'OK',
    retry: 'Retry',
    authExpired: 'Session not confirmed — please log in again.',
    serverError: 'The server did not respond. Please try again.',
    itemLevel: 'level {n}',
    overflowTitle: 'Second chest — for going over the goal (every {n} extra points):',
    title: 'Daily quests',
    subtitle: 'Six quests worth {total} points — collect any {need} and open the chest',
    dayEndsIn: 'day resets in',
    streakBurns: 'streak burns in',
    weekTitle: 'Week · tier {tier} of {max}',
    weekTierHint: 'The tier sets the quality of the Friday and Sunday item. Complete the week and it goes up one step, miss it and it drops by one. From the top step the ladder starts over.',
    weekTierTop: '⭐ Top step: Friday and Sunday bring a unique class item. From next week the ladder starts over.',
    streakDays: 'streak {n} d.',
    forWeekChest: 'to the weekly chest',
    insuranceReady: 'insurance: available',
    insuranceUsed: 'insurance: spent',
    chestOf: '{day} chest',
    chestSurprise: 'surprise',
    routesLeft: '{n} points to the chest — any route will do:',
    routesDone: 'Daily chest opened — extra points now give tickets:',
    leftShort: '{n} points to the chest',
    chestOpen: 'Daily chest unlocked',
    routeHard: 'one hard',
    routeMix: 'medium + easy',
    routeEasy: 'two easy',
    claim: 'Claim',
    claimAll: 'Claim all ({n})',
    rerollHint: 'Replace the quest (swaps left today: {n})',
    rerollConfirm: 'Sure?',
    monthTitle: 'Monthly milestone',
    monthPeek: 'what you get',
    monthProgress: 'Active days: {have} of {need}',
    monthChoiceTitle: 'Pick 1 of {n}',
    monthChoiceEpic: 'With a {pct}% chance one option will be epic',
    monthNote: 'Days in any order · unique class item + tickets',
    monthReady: 'Milestone complete — claim your reward',
    rewardMonth: 'Monthly milestone complete!',
    weekChestTitle: 'Weekly chest',
    weekChestNote: 'Arrives on Sunday · days collected: {have} of {need}',
    weekChestWhen: 'It comes ON TOP of the daily chest — as a separate chest in your storage.',
    weekChestTier: 'Tier {tier} of {max} sets the quality of the Friday and Sunday items.',
    pickWhere: 'Your pick and the rest of the reward travel as one chest to storage — it opens on a timer.',
    pickConfirmOne: 'Take: {name}',
    daysShort: 'd.',
    mailTitle: 'Reward stash',
    mailWaiting: 'Waiting rewards: {n}',
    mailEmpty: 'Empty — everything delivered',
    mailKeepHint: 'Rewards wait here as long as you like — claim them when you need them',
    mailHospital: 'Full army restoration',
    hospitalNote: 'Use it in «Figure settings» — it restores the whole army',
    mailClassItem: 'A class item of your choice',
    mailItem: 'A piece of gear',
    mailSource: { week_chest: 'Weekly chest', month: 'Monthly milestone', day_chest: 'Daily chest', overflow: 'Overflow chest' },
    toBattle: 'To battle',
    toPack: 'Figure settings',
    toBattleLeft: 'To battle — {n} points left',
    ctaNote: 'Matches beyond the quests still give loot, energy and rating as usual.',
    pickTitle: 'Choose your reward',
    pickNote: 'You take one of the options — the choice is yours',
    pickConfirm: 'Take the chosen one',
    levelShort: 'lv. {n}',
    // Item category in the choice description: «epic WEAPON», «unique CLASS ITEM»
    cat: { any: 'item', class_item: 'class item', weapon: 'weapon', armor: 'armor', jewelry: 'jewelry' },
    tier: {
      easy: 'easy',
      mid: 'medium',
      hard: 'hard',
      elite: 'very hard',
    },
    wd: {
      mon: 'mon', tue: 'tue', wed: 'wed', thu: 'thu', fri: 'fri', sat: 'sat', sun: 'sun',
    },
    wdFull: {
      mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday',
      fri: 'Friday', sat: 'Saturday', sun: 'Sunday',
    },
    res: {
      box: 'timed chest',
      energy: 'energy',
      tickets: 'tickets',
      gems_small: 'gems',
      materials: 'materials',
      boost_minutes: 'boost minutes',
      scroll_apprentice: 'apprentice scroll',
      scroll_master: 'master scroll',
      ether: 'ether',
      hammer: 'blacksmith’s hammer',
      whetstone: 'sharpening tool',
      transform_stone: 'transformation stone',
      chisel: 'chisel',
      ammo: 'equipment piece',
      class_item: 'class item',
      choice: 'items to choose from',
      choicePick: 'Pick 1 of {n}',
      hospital: 'full army healing',
    },
    q: {
      play_match_full: 'Play a match to the end',
      wheel_spin: 'Spin the wheel of fortune',
      disassemble_2: 'Disassemble 2 items',
      equip_item: 'Equip an item on a piece',
      heal_unit: 'Heal a piece',
      swap_positions: 'Rearrange a piece in the line-up',
      spectate_match: 'Watch someone else’s match as a spectator',
      season_join: 'Register for a tournament',
      fight_loot_3: 'Get 3 items in duels',
      market_list: 'List a lot on the market',
      win_match: 'Win a match',
      fight_streak_3: 'Win 3 duels',
      kill_5: 'Kill 5 enemy pieces',
      both_fractions: 'Play for both factions',
      ability_2: 'Use a class ability twice',
      revive_unit: 'Revive a piece',
      disassemble_5: 'Disassemble 5 items',
      referral_friend: 'Invite a friend via referral',
      skills_4: 'Use 4 skills or abilities',
      market_sold: 'Sell a lot on the market',
      king_spell_3: 'Cast the king’s spell 3 times',
      win_2_matches: 'Win 2 matches',
      fight_streak_6: 'Win 6 duels',
      win_flawless: 'Win without losing a single piece',
      king_before_20: 'Kill the enemy king before move 20',
      equip_full_3: 'Fully equip 3 pieces',
      season_match: 'Play a tournament match',
      win_vs_stronger: 'Win against a stronger opponent',
      promote_pawn: 'Promote a pawn',
    },
  },
  srvError: {
    cellTaken: 'The square is taken — attack the figure instead of moving onto it.',
    targetNotInFight: 'That figure is not in this duel.',
    targetIsAlly: 'You can only attack an enemy figure.',
    noHealthForSkill: 'Not enough health for this skill.',
      starsOff: 'The shop is temporarily unavailable',
      starsTgDown: 'Telegram is not responding right now — please try again later',
      starsNoProduct: 'No such bundle',
      starsBadProduct: 'This bundle is temporarily unavailable',
      starsPriceChanged: 'The price has changed — refresh the shop',
      starsBlacklisted: 'Purchases are not available for this account',
      starsRefundBlock: 'Purchases are closed: too many refunds on this account. Message /paysupport to the bot',
      walletTaken: 'This wallet is already linked to another player',
      walletPayloadGone: 'The linking code expired — start the connection again',
      walletNeeded: 'Link a TON wallet first',
      noStockToReturn: 'Nothing to put back in place of the NFT figure — return your own figure of that class to the reserve first',
      bakedFrozen: 'The kit is baked into the NFT — unlock the figure first',
      bakeNothing: 'The figure has no equipment — nothing to bake',
      bakeAlready: 'This kit is already baked',
      bakeNotBaked: 'This kit is not baked',
      noBalanceEnergy: 'Not enough energy on your balance',
      notNftUnit: 'This is not an NFT warrior',
      bakeOnMarket: 'Part of the kit is listed on the Market — cancel the listing first',
      swapBaked: 'Cannot swap equipment: part of a kit is baked into an NFT — unlock the figure first',
      unitInReserve: 'This figure is in reserve — put it into the squad first',
      tutorialRestartUsed: 'The tutorial can be started over only once',
      swapSquadReserve: 'A squad figure swaps with a reserve figure',
      swapOtherFraction: 'These figures belong to different factions',
      swapOtherClass: 'Only a figure of the same class can replace it',
      unitNotReady: 'Restore the figure first',
    pwdWrongCurrent: 'Current password is wrong',
    pwdSameAsOld: 'New password matches the old one',
    nameTaken: 'This name is taken',
    pwdShort: 'Password must be at least {n} characters',
    pwdLong: 'Password must be at most {n} characters',
    pwdBlank: 'Password cannot be only spaces',
    pwdSameAsName: 'Password must not match your player name',
    nameLen: 'Name must be {n} to {m} characters',
    noTickets: 'No tickets left',
    noEnergy: 'Not enough energy',
    tooManyTickets: 'Too many tickets at once',
    badTicketCount: 'Invalid ticket amount',
    unknownSector: 'Unknown wheel sector',
    userNotFound: 'Player not found',
    seasonNotFound: 'Tournament not found',
    seasonRegClosed: 'Registration for this tournament is closed',
    seasonFull: 'No free seats left in the tournament',
    seasonOther: 'You already take part in another active tournament',
    seasonNotIn: 'You do not take part in this tournament',
    seasonNotPlayed: 'You did not take part in this tournament',
    mainAccountOnly: 'Available from the main account only',
    seasonJoinRetry: 'Registration failed, please try again',
    transferWindow: 'Transfer is available only after the tournament ends',
    noHammer: 'No blacksmith’s hammer — disassemble one by one or buy a hammer at the Market',
    nothingPicked: 'No items selected',
    ticketDailyLimit: 'Daily ticket limit ({n}) reached',
    ticketsLeftToday: 'You can buy no more than {n} tickets today',
    seasonEntryTickets: 'Tickets required to join: {n}',
    maxHammers: 'No more than {n} hammers at once',
    needHammers: 'You need {n} hammers but have {m} — buy hammers at the Market or pick fewer items',
    maxItems: 'No more than {n} items at once',
    unitDeadAmmo: 'The piece is dead — its gear is locked until revival',
    unitWounded: 'The piece is wounded — heal it first',
    unequipFirst: 'Unequip the item from the piece first, then list it',
    soilDrains: 'The Soil drains the king’s resources — the skill is unavailable',
    questNotFound: 'Quest not found',
    questOldDay: 'This quest belongs to a past day',
    questNotDone: 'Quest is not completed yet',
    rewardTaken: 'Reward already claimed',
    rerollUsed: 'Free reroll for today is already used',
    noOtherQuest: 'No other quest of this difficulty',
    chestNotReady: 'The daily chest is not unlocked yet',
    chestTaken: 'The daily chest is already claimed',
    mailNotFound: 'Letter not found',
    choiceUnavailable: 'Nothing to choose right now',
    noSpace: 'No free slot — free one up first',
    chestFull: 'Chest is full',
    noMaterials: 'Not enough materials',
    tooManyRequests: 'Too often — wait a few seconds and try again',
    noGems: 'Not enough gems',
    unknownScroll: 'Unknown scroll',
    badCount: 'Invalid amount',
    badMinutes: 'Invalid number of minutes',
    noMinutes: 'No boost minutes left',
    noEther: 'No ether left',
    noApprenticeScroll: 'No apprentice scroll',
    noMasterScroll: 'No master scroll',
    chargesFull: 'Charges are already full',
    rentOfferGone: 'This offer is no longer available',
    rentOwnFigure: 'You cannot rent your own figure',
    rentFigureGone: 'The owner no longer has this figure',
    rentTermsChanged: 'The owner changed the terms — refresh the listings',
    rentFigureHealing: 'The figure is recovering — try again later',
    rentFigureListed: 'The figure is listed for sale on-chain — cancel the listing first',
    rentNeedsBaked: 'Only a figure with a baked kit can be rented out',
    rentNftOnly: 'Only NFT warriors can be rented out',
    rentNoSeason: 'Renting is unavailable in a tournament',
    rentInMatch: 'A match is in progress — try again after it ends',
    rentSelfDeal: 'Renting between linked accounts is not allowed',
    rentNoEarlyReturn: 'A fixed-price rental cannot be returned early — wait until the term ends',
    rentReturnHealthy: 'Heal the figure first — it returns to its owner in full health',
    rentLeaveSquad: 'Take the figure out of the battle squad first',
    rentAlreadyRecalled: 'The figure is already recalled and returns after the renter\u2019s match',
    rentClosed: 'This rental is already closed',
    rentAlreadyRented: 'This figure is already rented out',
    rentAlreadyOffered: 'This figure is already listed for rent',
    rentAlreadyLent: 'This figure is already lent out',
    rentUnlistFirst: 'This figure is listed for rent — cancel the offer first',
    rentGearLocked: 'The figure is rented — only its owner changes the gear',
    rentLent: 'The figure is rented out',
    rentReturnFirst: 'The figure is rented out — return it to its owner first',
    rentTermsLocked: 'Terms of an accepted rental cannot be changed',
    rentOfferExpired: 'This offer has expired',
    rentOfferNotFound: 'Offer not found',
    rentNotFound: 'Rental not found',
    rentOfferCancelled: 'This offer has already been cancelled',
    rentOnePayment: 'Pick exactly one payment: per day OR a share of earnings',
    rentPercentRange: 'Percent must be between 1 and 100',
    rentPriceRange: 'Daily price is out of range',
    rentBadPrice: 'Invalid rental price',
    rentBadPercent: 'Invalid percent',
    rentBadDays: 'Invalid rental term',
    rentBadTerm: 'Invalid term',
    rentNeedEnergy: 'Not enough energy: {n} needed',
    rentDaysRange: 'Rental term is 1 to {n} days',
    rentRecallNeedFull: 'The recall costs {n} energy, you have {m}',
    rentRecallNeed: 'The recall costs {n} energy',
    nowhereToUnequip: 'Nowhere to put the old gear: inventory and chest are full',
    noFractionUnits: 'You have no units of this faction',
    unitNotFound: 'Unit not found',
    unknownFraction: 'Unknown faction',
    boostInMatch: 'Boost is unavailable during a match',
    careInMatch: 'Healing and revival are unavailable during a match',
    ammoInMatch: 'Gear cannot be changed during a match',
    minMinutes: 'At least {n} minutes (one gem)',
    maxMinutes: 'No more than {n} minutes at once',
    maxScrolls: 'No more than {n} scrolls at once',
    maxCharges: 'No more than {n} charges at once',
    itemNotFound: 'Item not found',
    itemOnMarket: 'The item is listed on the Market — cancel the listing first',
    matchNotFound: 'Match not found',
    unequipFirstItem: 'Unequip the item first',
    unitInvFull: 'The figure’s inventory is full',
    wrongSlot: 'The item does not fit this slot',
    slotBusy: 'The slot is taken',
    itemNotEquipped: 'The item is not equipped',
    backItemBad: 'The item coming back does not fit: {n}',
    swapWounded: 'Cannot swap gear: some figures are not restored — heal or revive them first',
    swapSelf: 'Cannot swap a figure with itself',
    swapSameType: 'Only figures of the same type can be swapped',
    nowhereUnequipShort: 'Nowhere to put it: inventory and chest are full',
    rechargeClassOnly: 'Only class items can be recharged',
    rechargeCurrency: 'Unknown recharge currency',
    rechargeNoEnergy: 'Not enough energy to recharge',
    transferInMatchOnly: 'Items can be handed over only during a match',
    itemNotInUnitInv: 'The item is not in the figure’s inventory',
    transferSelf: 'Cannot hand the item to the same figure',
    unitNotOnBoard: 'The figure is not on the board',
    unitsNotAdjacent: 'The figures are not on adjacent cells',
    pickUnitOrFraction: 'Pick a figure or a faction',
    consumablesSeason: 'Boosts are shared across tournaments — trade them from the main account',
    marketOffSeason: 'The Market is disabled in this tournament',
    badPrice: 'Invalid price',
    minPrice: 'Minimum price — {n} energy',
    priceRange: 'The price is out of range',
    badResPrice: 'Invalid resource price',
    unknownPriceRes: 'Unknown resource in the price',
    priceGemsOnly: 'Only small gems can be used as a price',
    badResCount: 'Invalid resource amount',
    resCountRange: 'The resource amount is out of range',
    itemAlreadyListed: 'The item is already listed on the Market',
    unknownRes: 'Unknown resource',
    sellGemsOnly: 'Only small gems can be sold',
    countMin1: 'The amount must be at least 1',
    notEnoughRes: 'Not enough of that resource',
    lotNotFound: 'Listing not found',
    lotNotYours: 'This listing is not yours',
    lotClosed: 'The listing is already closed',
    chestFullReturn: 'The chest is full — free a slot to take the item back',
    lotGone: 'The listing is already sold or cancelled',
    lotOwn: 'You cannot buy your own listing',
    lotOtherWorld: 'This listing belongs to another world (tournament or main account)',
    selfTrade: 'Deal blocked: systematic trading with a linked account',
    notEnoughForBuy: 'Not enough resources to buy',
    lotItemGone: 'The listed item is unavailable',
    chestFullBuy: 'The chest is full — free a slot to buy',
    unknownGoods: 'Unknown goods',
    goodsNotFound: 'Goods not found',
    seasonEnterWindow: 'You can enter a tournament only while it is open or running',
    transferResChanged: 'The tournament profile resources changed — repeat the transfer',
    transferBalChanged: 'The tournament profile balance changed — repeat the transfer',
    unknownTour: 'Unknown tour',
    unknownTutStep: 'Unknown tutorial step',
    tutStepNotStarted: 'This tutorial step has not started yet',
    unknownChecklist: 'Unknown entry',
    checklistNotDone: 'The entry is not completed yet',
    unknownAct: 'Unknown tutorial act',
    noResForTickets: 'Not enough resources to buy tickets',
    badSpins: 'Invalid number of spins',
    maxSpins: 'No more than {n} spins at once',
    ticketsLessThanSpins: 'You have fewer tickets than spins',
    notEnoughResources: 'Not enough resources',
    noHospital: 'No full army healing boost',
    nameChars: 'The name may contain letters, digits, space, hyphen, dot and underscore',
    matchFinished: 'The match is already over',
    // in-match refusals (socket `error`) — shown as a toast in `/play-web`
    gmOtherFraction: 'It is the opponent’s turn',
    gmNotYourUnit: 'This is not your piece',
    gmUnitNotInMatch: 'This piece is not in this match',
    gmCaptureViaFight: 'Captures go through a duel',
    gmMatchOver: 'The match is already over',
    gmNotYourMatch: 'This is not your match',
    gmNoSession: 'Session not found — please re-enter the game',
    gmNotSpectatable: 'This match cannot be watched',
    gmMaintenance: 'Maintenance in progress — new matches are unavailable',
    gmArmyNotReady: 'Army is not restored: heal or revive your pieces, or wait for the timer',
    gmBadMove: 'You cannot move there',
    gmBadCell: 'Invalid cell',
    gmZeroSpeed: 'This piece has no initiative left',
    gmNoAttackTarget: 'There is nothing to attack here',
    gmNoTargetOnBoard: 'No target on the board',
    gmNoFightNow: 'You cannot start a fight right now',
    gmSkillKingOnly: 'Only the King has a skill',
    gmKingNoSkill: 'This King has no active skill',
    gmAbilityKingOnly: 'Only the King casts a class ability on the board',
    gmNoSkillNow: 'You cannot cast the skill right now',
    gmNoAbilityNow: 'You cannot use the ability right now',
    gmSkillNeedsTarget: 'Pick a target for the skill',
    gmAbilityNeedsTarget: 'Pick a target for the ability',
    gmBadSkillTarget: 'Invalid skill target',
    gmTargetMustBeAlly: 'The skill target must be an ally',
    gmTargetMustBeEnemy: 'The skill target must be an enemy',
    gmImmuneRoyals: 'The enemy King and Queen are immune to magic',
    gmNoClassAbility: 'This piece has no class ability',
    gmCloakedCannotAttack: 'A piece under the Cloak cannot attack',
    gmExtraTurnKnightOnly: 'Only the Knight that used Haste may take the second move',
    gmPetrified: 'The figure is petrified: it has almost no health left',
    gmCloakedCannotBeHit: 'This piece cannot be attacked: it is under the Cloak',
    gmSpellNotInBook: 'This spell is not available to the book',
    gmTargetTooFar: 'The target is too far away',
    gmSpellTargetAlly: 'The spell target must be an ally',
    gmSpellTargetEnemy: 'The spell target must be an enemy',
    gmAbilityTargetOutOfFight: 'The ability target is outside the fight',
    gmNoSkillResources: 'Not enough resources for the skill',
    gmSkillFailed: 'The skill was not cast — not enough resources',
    gmOtherUnitTurn: 'It is another piece’s turn',
    gmAlreadyActed: 'This action has already been taken this turn',
    gmTargetInvisible: 'The target is invisible',
    gmWallBlocks: 'Your subclass is blocked by the Wall — attack the Wall',
    gmWallOnCell: 'A Wall blocks that tile',
    gmWallFar: 'The wall can only be placed on an adjacent tile',
    gmCellBusy: 'That tile is occupied by a piece',
    gmWallHere: 'A Wall already stands on that tile',
    gmWarriorAttackThrough: 'A Warrior cannot attack through another piece',
    gmWarriorSkillThrough: 'A Warrior cannot use a skill through another piece',
    gmSeasonNotStarted: 'The tournament has not started yet — matches open on the start date',
    gmSeasonOver: 'The tournament is over — results are final, no new matches',
    gmSeasonClosed: 'Tournament matches are currently unavailable',
    gmAbCellNeeded: 'Pick a tile on the board',
    gmAbNoCharges: 'The ability is out of charges',
    gmAbCasterOffField: 'The caster is off the battlefield',
    gmAbCellTaken: 'That tile is occupied',
    gmAbBadSpellTarget: 'Invalid spell target',
    gmAbUnknownSpell: 'Unknown spell',
    gmAbOwnWall: 'You cannot attack your own Wall',
    gmAbFightOnly: 'This ability works only in a duel',
    gmAbWallOwnHalf: 'The wall can only be placed on your half of the field',
    gmAbNoWall: 'There is no Wall on the field',
    gmAbNoClassItem: 'This piece carries no class item',
    gmAbNoAbility: 'This piece has no class ability',
    gmAbTargetNotFound: 'Ability target not found',
    gmAbNotOnWall: 'This ability cannot be used on a Wall',
    playerNotFound: 'Player not found',
    rentDeleteInMatch: 'The player is in a match with a rented piece — deletion is possible once it ends',
  },
  tgWelcome: {
    title: 'Welcome to ChessZombies',
    text: 'You opened the game from Telegram. Create a new player or sign in to the account you already have?',
    newPlayer: 'I am a new player',
    haveAccount: 'I already have an account',
    hint: 'If you sign in to an existing account, Telegram will be linked to it — next time the game opens instantly, no password needed.',
    failed: 'Could not create a player. Please reopen the game from Telegram.',
  },
  rarity: {
    common: 'Common',
    rare: 'Rare',
    super_rare: 'Super rare',
    unique: 'Unique',
    epic: 'Epic',
    commonM: 'Common',
    rareM: 'Rare',
    super_rareM: 'Super rare',
    uniqueM: 'Unique',
    epicM: 'Epic',
    commonLow: 'common',
    rareLow: 'rare',
    super_rareLow: 'super rare',
    uniqueLow: 'unique',
    epicLow: 'epic',
  },
};
